import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CoreTargetService } from '../core/services/target.service';
import { getCurrentEnv } from '../core/http/env-utils';

/**
 * Adds Ads query params when calling Ads endpoints:
 *  - shopID (CoreTargetService)
 *
 * Detection:
 *  - Either the request path starts with '/ads/' (pre-rewrite), OR
 *  - The absolute URL starts with the configured Ads base (post-rewrite).
 */
export const AdsParamsInterceptor: HttpInterceptorFn = (req, next) => {
  const env = getCurrentEnv();
  const adsBase = env.ads; // e.g., https://ads.behamics.com

  // Support both pre- and post-rewrite forms
  const path = (req.url.split('?')[0] || '').trim();
  const isPreRewrite = path.startsWith('/ads/');
  const isPostRewrite =
    typeof adsBase === 'string' && req.url.startsWith(adsBase);
  const isAds = isPreRewrite || isPostRewrite;
  if (!isAds) return next(req);

  const shopID = inject(CoreTargetService).getSelectedTarget('target') || '';

  const hasShop = req.params.has('shopID');
  if (hasShop) return next(req);

  const setParams: Record<string, string> = {};
  if (!hasShop) setParams['shopID'] = shopID;

  return next(req.clone({ setParams }));
};
